import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent, initGlobalClickListener } from '../../utils/logger';

const PageTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Initialize Global Click Listener once
        initGlobalClickListener();
    }, []);

    useEffect(() => {
        // Log Page View on location change
        logEvent('VIEW', null, 'SUCCESS');
    }, [location]);

    return null; // This component renders nothing
};

export default PageTracker;
